export { default as GDMListItemIcon } from './GDMListItemIcon';

export type { GDMListItemIconComponent, GDMListItemIconProps } from './GDMListItemIcon.type';
